import sentryInit from "./sentry";

import { createApp } from "vue";
import { sync } from "vuex-router-sync";

import "reset-css";
import "./css/tailwind/index.css";

import App from "./App.vue";
import router from "./router";
import store from "./store";

// Auto-track `router.currentRoute` as `store.state.route`.
sync(store, router);

const app = createApp(App);

sentryInit(app, router);

app.use(router).use(store).mount("#app");
